import type { Building } from "building-types/building/buildingTypes";
import type { CeilingSection } from "building-types/ceilings/ceiling";
import type { BuildingGeometryEmitter } from "building-types/geometry/buildingGeometryTypes";
import { roomEntityHandleForSelectingReportingUnit } from "building-types/handles/roomEntityHandleForSelectingReportingUnit";
import { FaceCategory } from "building-types/materials/faceCategories";
import { faceGroupNew } from "geom/brep";
import { UVGeneration } from "geom/uv";
import { buildInteriorLayers } from "./buildingGeometryTools";

// This code isn't yet merged with the geometry gen in renderCeilings. There's a significant chunk of
// work to merge them because of the specialized logic in the render stage.
export function getCeilingGeometries(building: Building, emitter: BuildingGeometryEmitter): void {
  const { ceilings, ceilingsByLevel, rooms } = building;

  function iterateCeilingSection(section: CeilingSection, levelId: string) {
    const { ceilingFaces, materialSlot, designMaterialId, roomId } = section;

    if (ceilingFaces.length === 0) {
      return;
    }

    // Assign interior room layers for proper lighting (interior ambient light uses BUILDING_INTERIOR_LAYER)
    const room = rooms[roomId];
    const threeLayers = buildInteriorLayers(true);

    const entityHandleForSelectingReportingUnit = roomEntityHandleForSelectingReportingUnit(room);

    emitter.emit({
      geom: faceGroupNew(ceilingFaces),
      materialSlot,
      materialSrc: designMaterialId,
      faceCategory: FaceCategory.CEILING,
      uvGen: UVGeneration.GLOBAL_RECT_UV,
      threeLayers,
      entityId: roomId,
      levelId,
      aboveLevel: true,
      pickHandle: room?.pickHandle,
      entityHandleForSelectingReportingUnit,
    });
  }

  for (const levelId in ceilingsByLevel) {
    const ceilingIds = ceilingsByLevel[levelId];

    for (const ceilingId of ceilingIds) {
      const ceiling = ceilings[ceilingId];

      const { subCeilings } = ceiling;
      for (const subCeiling of subCeilings) {
        for (const section of subCeiling.sections) {
          iterateCeilingSection(section, levelId);
        }
      }
      iterateCeilingSection(ceiling.section, levelId);
    }
  }
}
